import { Component, Input } from '@angular/core';

import { TimelineItemInterface } from '~/component/timeline/interfaces/item.interface';

@Component({
  selector: 'app-timeline-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class TimelineListComponent {
  @Input() public collection: TimelineItemInterface[] = [];
}
